export enum PRAYER_TYPE {
  INTENTION = 'intention',
  BIRTHDAY = 'birthday-intention',
  ARRIVAL = 'arrival-intention',
}
